import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=48e32a73&scoped=true"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"
import style0 from "./productType.vue?vue&type=style&index=0&id=48e32a73&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e32a73",
  null
  
)

export default component.exports